var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-popover" },
    [
      _c(
        "v-popups",
        {
          attrs: {
            "custom-style": { width: _vm._width },
            trigger: _vm.trigger,
            "show-arrow": _vm.showArrow,
            position: _vm.position,
            transition: _vm.transition,
            enterable: _vm.enterable,
            "open-delay": _vm.openDelay,
            "close-delay": _vm.closeDelay,
            "between-space": _vm.betweenSpace,
            "auto-adjust-position": _vm.autoAdjustPosition,
          },
          on: { "visible-change": _vm.visibleChange },
          scopedSlots: _vm._u(
            [
              {
                key: "reference",
                fn: function () {
                  return [_vm._t("reference")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        [
          _c("div", { staticClass: "v-popover__main" }, [
            _c(
              "div",
              { staticClass: "v-popover__content" },
              [_vm._t("default")],
              2
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }